import { css } from 'emotion';

import { icons } from '../styles';

export const iconWrapper = css`
  > svg {
    height: ${icons.size.small};
    width: ${icons.size.small};
  }
`;
